module.exports = __webpack_public_path__ + "images/e39e025568f1c997a5229f9c08ce94afstamp.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stamp.png
// module id = F/i7
// module chunks = 0